"use client";

import { useCompositeSeparator } from "../__chunks/TP7N7UIH.js";
import "../__chunks/A3CZKICO.js";
import { useToolbarContext } from "../__chunks/A3WPL2ZJ.js";
import "../__chunks/P7GR5CS5.js";
import "../__chunks/VDHZ5F7K.js";
import { createElement, createHook, forwardRef } from "../__chunks/LMDWO4NN.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/toolbar/toolbar-separator.tsx
var TagName = "hr";
var useToolbarSeparator = createHook(function useToolbarSeparator2(_a) {
  var _b = _a,
    store = _b.store,
    props = __objRest(_b, ["store"]);
  var context = useToolbarContext();
  store = store || context;
  props = useCompositeSeparator(__spreadValues({
    store: store
  }, props));
  return props;
});
var ToolbarSeparator = forwardRef(function ToolbarSeparator2(props) {
  var htmlProps = useToolbarSeparator(props);
  return createElement(TagName, htmlProps);
});
export { ToolbarSeparator, useToolbarSeparator };